var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogsInactive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.455 4h13.09a1.455 1.455 0 0 1 0 2.91H5.456a1.455 1.455 0 1 1 0-2.91ZM3 5.455A2.455 2.455 0 0 1 5.455 3h13.09a2.455 2.455 0 0 1 0 4.91H5.456A2.455 2.455 0 0 1 3 5.454ZM4.311 15.7a.5.5 0 0 0-.625.78l2.012 1.61-2.012 1.61a.5.5 0 0 0 .625.78l2.988-2.39zm14.235-5.156H5.455a1.455 1.455 0 1 0 0 2.91h13.09a1.455 1.455 0 0 0 0-2.91Zm-13.091-1a2.455 2.455 0 1 0 0 4.91h13.09a2.455 2.455 0 0 0 0-4.91zm5.999 7.546h7.09a1.455 1.455 0 1 1 0 2.91h-7.09a1.455 1.455 0 0 1 0-2.91m-2.455 1.455a2.455 2.455 0 0 1 2.455-2.455h7.09a2.455 2.455 0 1 1 0 4.91h-7.09a2.455 2.455 0 0 1-2.455-2.455",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogsInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logs-inactive.1d502d84.svg";